import { useContext } from "react";
import { BNDataLayerCtx } from "../context/BNDataLayerCtx";
export var useBNDataLayer = function () {
    var ctxConsumer = useContext(BNDataLayerCtx);
    return ctxConsumer;
};
//# sourceMappingURL=useBNDataLayer.js.map